import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AiRepository, CircleDetection } from '../core';


/**
 * This service handles data from ai services.
 */
@Injectable({ providedIn: 'root' })
export class AiService {

	private readonly aiRepo = inject(AiRepository);

	circleDetection(image: File): Observable<CircleDetection> {
		return this.aiRepo.circleDetection(image);
	}
}